import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import { IEcwidDataStatistics } from '@boxx/gmb-core/lib/contracts/IEcwidData';
import {
  IPanelAnalyticsResponse,
  IPanelStateError,
  IPanelStateSuccess,
} from '@boxx/panel-core';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as fromActions from './panel.actions';

export interface PanelState {
  analytics: any;

  ecwidData: BoxxGenericState<
    IEcwidDataStatistics,
    IPanelStateSuccess,
    IPanelStateError
  >;
}

const initialState: PanelState = {
  analytics: { ...getGenericInitialState() },
  ecwidData: { ...getGenericInitialState()}
};

const reducer: ActionReducer<PanelState> = createReducer(
  initialState,
  on(fromActions.getAnalyticsBeginAction, (state) => ({
    ...state,
    analytics: {
      ...state.analytics,
      isLoading: true,
      error: null,
      success: null,
    },
  })),
  on(fromActions.getAnalyticsSuccessAction, (state, { payload }) => ({
    ...state,
    analytics: {
      ...state.analytics,
      data: payload,
      isLoading: false,
      success: { after: 'GET' },
      fetched: true,
    },
  })),
  on(fromActions.getAnalyticsFailAction, (state, { errors }) => ({
    ...state,
    analytics: {
      ...state.analytics,
      isLoading: false,
      error: { after: 'GET', error: errors },
    },
  })),


      //ECDIW DATA STADISTICS

      on(fromActions.getEcwidDataStatusBeginAction, (state) => ({
        ...state,
        ecwidData: {
          ...state.ecwidData,
          isLoading: true,
          error: null,
          success: null,
        },
      })),
      on(fromActions.getEcwidDataStatusSuccessAction, (state, { data }) => ({
        ...state,
        ecwidData: {
          ...state.ecwidData,
          data,
          isLoading: false,
          success: { after: 'GET' },
          fetched: true,
        },
      })),
      on(fromActions.getEcwidDataStatusFailAction, (state, { errors }) => ({
        ...state,
        ecwidData: {
          ...state.ecwidData,
          isLoading: false,
          error: { after: 'GET', error: errors },
        },
      }))

);

export const panelReducer = (state: PanelState | undefined, action: Action) =>
  reducer(state, action);
